import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupNotes extends MagstimInputGroup {

    constructor() {
		super();

		this.state = {
            noteText: undefined,
            noteTextFromProps:undefined
		};
	}

    static getDerivedStateFromProps(props, state) {
        if(state.noteTextFromProps !== props.noteText){
            state.noteText =  props.noteText;
            state.noteTextFromProps =  props.noteText;
        }

		return state;
    }
    
    onChange(e) {
        this.setState({noteText: e.target.value})

        if(this.props.onChange !== undefined){
            this.props.onChange(e.target.value);
        }
    }
    
    render() {

        return(
            <>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroup size={CurrentTheme().ControlSize} >

                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText className="input-group-text-top-align">{this.props.title}</InputGroupText>
                    </InputGroupAddon>

                    <Input type="textarea" autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus} 
                        rows={this.props.rows}
                        name="notes"
                        placeholder={this.props.title}
                        value={this.state.noteText}
                        innerRef={this.props.inputRef}
                        onChange={(value) => this.onChange(value)}
                    />

                </InputGroup>
            </>
        );
    }
}

MagstimInputGroupNotes.propTypes = {
    title: PropTypes.string,
    inputRef:PropTypes.object,
    rows:PropTypes.number,
    noteText: PropTypes.string,
    onChange:PropTypes.func
};

MagstimInputGroupNotes.defaultProps = {
    title: "",
    inputRef:undefined,
    rows:4,
    noteText:"",
    onChange:undefined
    
};

export default MagstimInputGroupNotes